import Button from 'components/ui-components/Button';

const SpottedMistakeConfirmation = ({ closeModal }) => (
  <>
    <h2 className="ff-body fw-600 fs-32 tc-grey-70 mb-16">
      Your message has been sent
    </h2>
    <p className="ff-body tc-grey-70 fs-16 mb-30">
      Thank you for taking the time to notify us of a mistake on this page.
    </p>
    <Button
      handleClick={closeModal}
      className="cef-btn cef-btn--red cef-btn--xl fw-600 fs-16 mt-60 mr-8">
      Close
    </Button>
  </>
);

export default SpottedMistakeConfirmation;
